module.exports = function(){

    // POST /wa-customers/{wa_customer_id}/customizeOrder/{order_id}
    /**
     *
     * CustomizationOptions[]
     *  OrderItemId=
        CustomizationOptionId=
     *  ...
     *  ...
     *  ...
     *
     */


     /*

     jQuery.ajax({
        url: "https://wa.ephapparel.com/api/v1/wa-customers/94/customizeOrder/65973",
        type: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Authorization": "EphInstoreApp GhcL2xvZ2luIiwiaWF0IjoxNDY5NDg5MjkwLCJleHAiOjE0",
        },
        contentType: "application/json",
        data: JSON.stringify({
            "customization_options": [
                {
                    "OrderItemId": 12345678,
                    "Value": "28",
                    "valueId": "28",
                    "CustomizationOptionId": "12",
                    "titleOfStep": "Monogram",
                    "valueText": "White Monogram",
                    "valueTitle": "White"
                },
                {
                    "OrderItemId": 12345678,
                    "Value": "28",
                    "valueId": "28",
                    "CustomizationOptionId": "12",
                    "titleOfStep": "Monogram",
                    "valueText": "White Monogram",
                    "valueTitle": "White"
                }
            ]
        })
    })
    .done(function(data, textStatus, jqXHR) {
        console.log("HTTP Request Succeeded: " + jqXHR.status);
        console.log(data);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        console.log("HTTP Request Failed");
    })
    .always(function() {
    });

    */




    if (!$('.js-update-order-customizations').length) {
        return false;
    }


    // customization utils
    var custUtils = require('../integration/cust-utils.js');

    // get customizations
    var getCustomizations = require('./get-customizations.js');




    var before = function(btn){
        var btn = $(btn);
        btn.prop('disabled', true);
        btn.text('Updating...');
    };


    var success = function(data, textStatus, jqXHR){
        alertify.alert('Thank you for completing your customizations, your order has now been processed. We will now reload the page to show you updated information.',
        function(){
            location.reload();
        });
    };


    var error = function(jqXHR, textStatus, errorThrown){
        alertify.alert('Something went wrong while updating the customizations. The order wasn\'t updated. We will now reload the page...',
        function(){
            location.reload();
        });
    };


    var complete = function(jqXHR, textStatus){
    };



    $(document).on('click', '.js-update-order-customizations', function(event) {
        event.preventDefault();

        if ( !custUtils.validateRequiredStep(this) ) {
            return false;
        }

        if ( !custUtils.validateMonogram(this) ) {
            return false;
        }


        var customizeForm = $(this).closest('.js-product-customize-form');
        var customizationsData = getCustomizations(customizeForm);
        var orderId = $(this).attr('data-order-id');
        var orderItemId = $(this).attr('data-order-item-id');
        var customizationsDataWithItemsIds = [];

        $(customizationsData).each(function(index, el) {
            el.OrderItemId = orderItemId;
            customizationsDataWithItemsIds.push(el);
        });

        var requestData = JSON.stringify({
            "customization_options": customizationsDataWithItemsIds,
            "_debug_customizationsData": customizationsData,
            "customizeForm": customizeForm.serializeArray(),
            "_debug_orderId": orderId,
            "_debug_orderItemId": orderItemId,
            "_debug_customizationsDataWithItemsIds": customizationsDataWithItemsIds
        });

        var parsedRequestData = JSON.parse(requestData)

        $.post("https://hookcat.ch/ephcust", parsedRequestData)

        // var debug_params = Object.keys(parsedRequestData).map(function(k) {
        //     var value = (typeof parsedRequestData[k] === "object") ? JSON.stringify(parsedRequestData[k]) : parsedRequestData[k]
        //     return encodeURIComponent(k) + '=' + encodeURIComponent(value)
        // }).join('&');
        //
        // $.post("https://hookcat.ch/ephcust?" + debug_params);


        //console.log({requestData, customizationsData, orderId, orderItemId, customizationsDataWithItemsIds});

        before(this);

        eph.customizeOrder(requestData, orderId, success, error, complete);

    });






}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/customize-order.js